if (!customElements.get('leni-art-gallery')) {
  customElements.define('leni-art-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const openers = [...this.querySelectorAll('.leni-image-open')];
      const dialog = this.querySelector('.leni-image-dialog');
      const expanded = this.querySelector('.leni-image-expanded');
      const zoom = this.querySelector('[data-image-zoom]');
      const stage = this.querySelector('.leni-image-stage');
      let current = 0;
      const show = index => {
        current = (index + openers.length) % openers.length;
        expanded.src = openers[current].dataset.fullImage;
        expanded.alt = openers[current].querySelector('img').alt;
        this.querySelector('[data-image-counter]').textContent = `${current + 1} / ${openers.length}`;
        stage.classList.remove('is-zoomed');
        zoom.textContent = 'Zoom in';
        zoom.setAttribute('aria-pressed', 'false');
        stage.scrollTo(0, 0);
      };
      this.addEventListener('click', event => {
        const thumbnail = event.target.closest('.leni-art-thumbnail');
        if (thumbnail) {
          const target = thumbnail.getAttribute('aria-controls');
          this.querySelectorAll('.leni-art-slide').forEach(slide => { slide.hidden = slide.id !== target; });
          this.querySelectorAll('.leni-art-thumbnail').forEach(item => { item.setAttribute('aria-pressed', String(item === thumbnail)); });
        }
        const opener = event.target.closest('.leni-image-open');
        if (opener && dialog) { show(Number(opener.dataset.imageIndex)); dialog.showModal(); }
        if (event.target.closest('[data-image-close]')) dialog.close();
        if (event.target.closest('[data-image-prev]')) show(current - 1);
        if (event.target.closest('[data-image-next]')) show(current + 1);
        if (event.target.closest('[data-image-zoom]')) {
          const zoomed = stage.classList.toggle('is-zoomed');
          zoom.textContent = zoomed ? 'Zoom out' : 'Zoom in';
          zoom.setAttribute('aria-pressed', String(zoomed));
        }
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }
      });
      if (dialog) {
        dialog.addEventListener('keydown', event => {
          if (stage.classList.contains('is-zoomed')) return;
          if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
        });
      }
    }
  });
}
